<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('service_exclusive_table')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Service Categories</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          placeholder="Title"
          v-model="service_data.title"
        >
        </base-input>

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 my-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 400 × 400px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div v-if="image">
          <p class="mb-2 text-danger">Image Preview</p>

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

          <img v-if="image" :src="image" ref="cover" />
        </div>

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            :src="$imageURL + '/' + service_data.icon"
            alt="uploaded-image"
          />
        </div>
        <quill-editor
          v-model="service_data.description"
          :options="editorOption"
          class="quill-h200px my-2"
        />
        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="service_data.isScrollSF">
            <p>
              <strong> <p class="col-blk">Scroll to Service Form.</p></strong>
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-3" v-model="service_data.isURL">
            <p>
              <strong> <p class="col-blk">Add URL</p></strong>
            </p></b-form-checkbox
          >
        </div>
        <template v-if="service_data.isURL">
          <div class="mb-2">
            <b-form-input
              class="mb-3"
              alternative
              name="URL"
              :rules="{ required: true }"
              placeholder="Enter your custom URL"
              v-model="service_data.link"
            >
              <p>
                <strong> <p class="col-blk">Add URL</p></strong>
              </p></b-form-input
            >
          </div>
        </template> -->
        <div class="mb-4">
          <p class="font-semibold text-lg">Membership Discounts</p>
          <template v-for="(item, index) in get_all_membership">
            <label>{{ item.name }}</label>
            <b-input
              v-model="memberDisc[item.name]"
              placeholder="Enter Discount"
              type="number"
              class="w-55"
            />
          </template>
        </div>
        <div class="mb-2 w-1/3">
          <label for="campaign">Campaigns:</label>
          <multiselect
            v-model="selectedCampaigns"
            :options="getCampaignOptions()"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Campaign"
            track-by="value"
            label="label"
            :preselect-first="false"
          ></multiselect>
        </div>
        <!-- 
        <div class="mb-2">
          <b-form-checkbox
            id="checkbox-3"
            v-model="service_data.showOnCampaign"
          >
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on campaign.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      image: "",
      icon: "",
      coverImage: "",
      Ctags: [],
      isScrollSF: false,
      isURL: false,
      link: "",
      selectedCampaigns: [],
      campaignOptions: [],
      editorOption: {
        theme: "snow",
      },
      pageData: {},
      service_data: {},
      imageErr: false,
      memberDisc: {},
      msg: {},
    };
  },
  computed: {
    ...mapState("services", {
      selectservice: "selectservice",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    campaignHome() {
      return this.$store.state.campaignPageBanner.campaignHome || {};
    },
  },
  watch: {
    pageData(val) {
      this.service_data = { ...val };
      // console.log(this.service_data);
      this.get_all_membership.forEach((element, index) => {
        // console.log(this.editProductData);
        this.memberDisc[element.name] =
          this.service_data.membershipDisc[element.name] == null
            ? 0
            : this.service_data.membershipDisc[element.name];
      });
    },
    "service_data.isScrollSF": function () {
      if (this.service_data.isScrollSF) this.service_data.isURL = false;
    },
    "service_data.isURL": function () {
      if (this.service_data.isURL) this.service_data.isScrollSF = false;
    },
  },
  methods: {
    getCampaignOptions() {
      return this.campaignHome && this.campaignHome.result
        ? this.campaignHome.result.map((campaign) => ({
            label: campaign.heading,
            value: campaign._id,
          }))
        : [];
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("_id", this.service_data._id);
      data.append("title", this.service_data.title);
      if (this.coverImage) data.append("icon", this.coverImage);
      data.append("description", this.service_data.description);
      // data.append("showOnCampaign", this.service_data.showOnCampaign);
      data.append(
        "selectedCampaigns",
        this.selectedCampaigns.map((campaign) => campaign.value)
      );

      if (this.service_data.isURL) {
        data.append("isScrollSF", false);
        data.append("isURL", this.service_data.isURL);
        data.append("link", this.service_data.link);
      } else if (this.service_data.isScrollSF) {
        data.append("isScrollSF", this.service_data.isScrollSF);
        data.append("isURL", false);
        data.append("link", " ");
      }
      data.append("membershipDisc", JSON.stringify(this.memberDisc));

      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch("services/edit", data);
        // if (editData.code == 200) {
        this.$router.push({ name: "service_exclusive_table" });
        this.$swal.fire({
          text: "Service Categories edited and saved",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectservice;
      if (this.selectservice.selectedCampaigns && this.campaignHome.result) {
        this.selectedCampaigns = this.selectservice.selectedCampaigns.map(
          (campaignId) => {
            const campaign = this.campaignHome.result.find(
              (c) => c._id === campaignId
            );
            return campaign
              ? { label: campaign.heading, value: campaign._id }
              : null;
          }
        );
        // .filter(Boolean);
      }
      await this.$store.dispatch("campaignPageBanner/get_campaignhome");
      // console.log("campaignHome122", this.campaignHome);
      // console.log(this.campaignHome, "campaignHome");
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  async mounted() {
    this.init();
    await this.get_all_membership.forEach((element, index) => {
      this.memberDisc[element.name] = 0;
      // this.discErr[element.name] = false;
    });
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
